import bem from 'utils/bem';

export const block = bem('tik-tok-auto-posting-upsell-modal');
